/** The server's code for "this ad advertises a promotion that is a draft". */
export const PROMOTION_NOT_PUBLISHED = 'PROMOTION_NOT_PUBLISHED';

/** The draft promotion a launch was refused for. */
export interface DraftPromotion {
  offerId: string;
  offerName: string;
}

/**
 * Read a launch refusal for a DRAFT promotion (HTTP 409,
 * `PROMOTION_NOT_PUBLISHED`, details `{ offerId, offerName }`).
 *
 * Nothing is launched when the server answers this, so the caller can name
 * the promotion, get the owner's go-ahead and retry — with
 * `publishDraftPromotion: true` on `POST meta-ads/launch`, or by publishing
 * the promotion first on any other launch path.
 */
export function readDraftPromotionError(error: unknown): DraftPromotion | null {
  if (!error || typeof error !== 'object') return null;
  const { code, details } = error as {
    code?: unknown;
    details?: Record<string, unknown>;
  };
  if (code !== PROMOTION_NOT_PUBLISHED || !details) return null;
  const { offerId, offerName } = details;
  if (typeof offerId !== 'string' || !offerId) return null;
  return {
    offerId,
    offerName:
      typeof offerName === 'string' && offerName ? offerName : 'Untitled',
  };
}
